import type { CookieChoices } from './types';

export const COOKIE_CONSENT_CONFIG = {
    COOKIE_NAME: 'cookie_consent',
    SHOW_COOKIE_CONSENT_NAME: 'show_cookie_consent_modal',
    COOKIE_EXPIRY_DAYS: 365,

    FLASH_TIMEOUT_MS: 500,

    COOKIE_CHOICES: {
        ESSENTIAL_ONLY: {
            essential: true,
            functional: false,
            analytics: false,
            targeting: false,
        },
        ALL_ACCEPTED: {
            essential: true,
            functional: true,
            analytics: true,
            targeting: true,
        },
    } satisfies Record<string, CookieChoices>,
} as const;
